import React, { useEffect } from 'react';
import { useAppData } from '../hooks/AppDataContext';
import { useState } from 'react';
import { useAuth } from '../hooks/AuthContext';
import PageLoader from './Generic/PageLoader';
import { isAuthenticated } from '../services/authService';

function AuthGuard(props) {
	const { setLoggedIn, setLoggedOut } = useAuth();
	const { setAccount } = useAppData();
	const [loaded, setLoaded] = useState(false);

	/**
	 * Checks to see if the user has valid cookies
	 */
	const checkCookies = async () => {
		const { isValid, account } = await isAuthenticated();

		if (isValid) {
			console.log('The account: ', account);
			if (account) setAccount(account);
			setLoggedIn();
			setLoaded(true);
			return;
		}

		setLoggedOut();
		setLoaded(true);
	};

	useEffect(() => {
		checkCookies();
	}, []);

	return <>{loaded ? props.children : <PageLoader />}</>;
}

export default AuthGuard;
